import { AdType } from '@/modules/adv/types'

import type { HbBidderConfig } from '../types'

type IndexExchangePlacement =
    | AdType
    | 'banner_1'
    | 'banner_2'
    | 'banner_3'
    | 'banner_4'
    | 'playhop_sidebar'
    | 'playhop_sidebar_small'

const IN_GAME_BANNER_SITE_ID = '1379783'

const SITE_IDS: Partial<Record<IndexExchangePlacement, string>> = {
    leaderboard: '1379784',
    leaderboard_rest: '1379784',
    sidebar: '1379785',
    playhop_sidebar: '1379785',
    playhop_sidebar_small: '1379785',
    sidebar_bottom: '1379786',
    sidebar_fullscreen: '1379786',
    sidebar_bottom_fullscreen: '1379785',
    sticky_desktop: '1379787',
    sticky_mobile: '1379788',
    sticky_mobile_non_game_page: '1379788',
    sticky_tablet: '1379788',
    rewarded: '1379782',
    interstitial_preroll: '1379780',
    interstitial_midroll: '1379781',
    interstitial: '1379781',
    universal_banner_1: IN_GAME_BANNER_SITE_ID,
    universal_banner_short_1: IN_GAME_BANNER_SITE_ID,
    universal_banner_2: IN_GAME_BANNER_SITE_ID,
    banner_1: IN_GAME_BANNER_SITE_ID,
    banner_2: IN_GAME_BANNER_SITE_ID,
    banner_3: IN_GAME_BANNER_SITE_ID,
    banner_4: IN_GAME_BANNER_SITE_ID,
}

export const INDEX_EXCHANGE_FALLBACK: HbBidderConfig = {
    bidder: 'ix',
    params: ({ type }) => {
        const siteId = SITE_IDS[type as IndexExchangePlacement]
        return siteId ? { siteId } : undefined
    },
}
